// Import everything from autoload folder
import './autoload/about-product-showcase.js'; import './autoload/ada-compliance.js'; import './autoload/anchor.js'; import './autoload/blog-articles.js'; import './autoload/blog-category-slider.js'; import './autoload/cart.js'; import './autoload/checkout.js'; import './autoload/faq-section.js'; import './autoload/header.js'; import './autoload/home-categories.js'; import './autoload/home-products.js'; import './autoload/lazyload.js'; import './autoload/menu.js'; import './autoload/mini-cart.js'; import './autoload/shop-category-slider.js'; import './autoload/shop-products.js'; import './autoload/single-product-collection.js'; import './autoload/single-product-related.js'; import './autoload/single-product.js'; import './autoload/testimonials-section.js'; // eslint-disable-line

// Import local dependencies
import { scrollIntoViewWithOffset } from './utils/helpers';

import ScrollOut from 'scroll-out';

/**
 * Set CSS variable for header height
 */
const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

const initDecorativeMotion = () => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-decorative-motion]').forEach((section) => {
    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    let frame = null;

    const update = () => {
      currentX += (targetX - currentX) * 0.1;
      currentY += (targetY - currentY) * 0.1;
      section.style.setProperty('--decorative-x', `${currentX.toFixed(2)}px`);
      section.style.setProperty('--decorative-y', `${currentY.toFixed(2)}px`);

      if (Math.abs(targetX - currentX) + Math.abs(targetY - currentY) > 0.1) {
        frame = window.requestAnimationFrame(update);
      } else {
        frame = null;
      }
    };

    const scheduleUpdate = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    section.addEventListener('pointermove', (event) => {
      if (reducedMotion.matches) return;

      const bounds = section.getBoundingClientRect();
      targetX = ((event.clientX - bounds.left) / bounds.width - 0.5) * 20;
      targetY = ((event.clientY - bounds.top) / bounds.height - 0.5) * 16;
      scheduleUpdate();
    });

    section.addEventListener('pointerleave', () => {
      targetX = 0;
      targetY = 0;
      scheduleUpdate();
    });
  });
};

/**
 * Scripts which runs after DOM load
 */

$(document).ready(function () {
  if (
    document.querySelector('[data-scroll]') &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    ScrollOut({ once: true, threshold: 0.08 });
  }

  initDecorativeMotion();

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (_, formId) {
    let target = document.getElementById(
      `gform_confirmation_wrapper_${formId}`
    );

    if (target) {
      scrollIntoViewWithOffset(target, 100);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // Create CSS variable for header height
  setHeaderHeight();
});
